import React from 'react'
import { Edit } from 'react-admin'

import VideosForm from './form'

export const VideoEdit = (props) => (
  <Edit undoable={false} {...props}>
    <VideosForm isEdit={true} {...props} />
  </Edit>
)

export default VideoEdit
